import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { postRequest } from '~services';
import {
  BaseQueryRequest,
  DistributionChannelsResponse,
  RECORD_STATUS,
  UseQueryOptionsType,
} from '~types';

export type DistributionChannelSortField = Record<string, never>;

export type DistributionChannelFilterField = Record<string, never>;

type DistributionChannelsRequest = BaseQueryRequest<
  DistributionChannelSortField,
  DistributionChannelFilterField
> & {
  name?: string;
  status?: RECORD_STATUS;
};

export const useQueryListDistributionChannel = (
  reqParams: DistributionChannelsRequest,
  options?: UseQueryOptionsType<
    DistributionChannelsRequest,
    DistributionChannelsResponse
  >,
) => {
  const getDistributionChannels = (): Promise<DistributionChannelsResponse> =>
    postRequest({
      path: 'api/distribution-channel/list',
      data: reqParams,
    }).then((res) => res.data);

  return useQuery(
    [QUERY_KEY.GET_LIST_DISTRIBUTION_CHANNEL, reqParams],
    () => getDistributionChannels(),
    { ...options },
  );
};
